'use client';

import { useTabsContext } from '..';

export const TabContent = ({ count, children }) => {
    const { activeTab, expand } = useTabsContext();

    return (activeTab === count || expand) && <>{children}</>;
};
